import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { InputPercent } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  inputOnChange,
  INPUT_TRACKING_TYPES,
  BedrockInterface,
} from '../../../../lib/utils';
import useAnalytics from '../../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const HomeInsuranceInput: React.FC<RentVsBuyInput> = ({
  value,
  errorMessage,
  analytics,
  dispatch,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const segmentAbstract = useAnalytics();
  const decimalValue = value;
  const percentageValue = !_.isNil(decimalValue)
    ? num.formatPercent(decimalValue)
    : '';
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_n',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        entityName: "homeowner's_insurance_annual_rate",
        field: "Homeowner's Insurance",
        field_type: 'user_type_input',
        field_value: e.target.value,
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'homeInsurance',
      calculator: RENT_VS_BUY,
      inputType: 'percentage',
    });
  };

  return (
    <InputPercent
      label={label}
      value={percentageValue}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
      decimalScale={3}
      numberOfDigits={3}
    />
  );
};

const mapStateToProps = (state) => ({
  value: state?.rentvsbuyCalculator?.inputs?.homeInsurance,
  errorMessage: state?.validations?.homeInsurance?.[0],
});

export default connect(mapStateToProps)(HomeInsuranceInput);
